import React, { useState } from "react";
import { useMutation } from "react-query";
import useLocale from "../hooks/useLocale";
import CustomAlert from "../pages/components/CustomAlert";
import GovGrButton from "./GovGrButton";
import GovGrModal from "./GovGrModal";

const GovGrDeleteModalDialog = ({
  open,
  close,
  message,
  title,
  deleteService,
  refetch,
  selectedItem,
  idFieldName,
  fieldName,
}) => {
  const [error, setError] = useState("");
  const { t } = useLocale();
  const { mutate } = useMutation(deleteService, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured, please try again later"));
        }
      }
    },
  });

  const handleDeleteItem = () => {
    mutate({ items: JSON.stringify([selectedItem?.[idFieldName]]) });
  };
  return (
    <GovGrModal customContent={true} open={open} close={close}>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <div className="flex flex-col items-center h-50">
        <h2 className="govgr-heading-l">{title}</h2>
        <p className="govgr-body">
          {message} {selectedItem[fieldName]}
          {t("?")}
        </p>
        <div className="flex items-center space-x-3">
          <GovGrButton
            onClick={handleDeleteItem}
            color="primary"
            buttonText={t("Submit")}
          />
          <GovGrButton
            onClick={close}
            variant="secondary"
            buttonText={t("Cancel")}
          />
        </div>
      </div>
    </GovGrModal>
  );
};

export default GovGrDeleteModalDialog;
